<template lang="html">
  <div class="item-cells product-tip" v-if="$store.state.tip">
    <div class="item-cell">
      <div class="item-cell-hd">提示</div>
      <div class="item-cell-bd" v-if="$store.state.tip.link === ''">
        {{ $store.state.tip.prompt }}
      </div>
      <div class="item-cell-bd" v-else @click="trace">
        <a :href="$store.state.tip.link">{{ $store.state.tip.prompt }}</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  PAGE_ID: '288990',
  methods: {
    trace() {
      this.trackClick(200001, '点击提示链接', {
        skuid: this.$route.query.skuId || '',
        spuid: this.$route.params.spuId || ''
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/css/mixin';

.product-tip {
  // margin: rem(20px) 0;
  // background: #fee7a0;
  // color: #9a7126;

  &::before {
    left: rem(20px);
    right: rem(20px);
  }

  .item-cell {
    align-items: flex-start;
    font-size: rem(28px);
    padding: 0 0 rem(30px) 0;
  }
  .item-cell-hd {
    padding-right: 0;
    color: #121212;
    font-weight: 700;
    font-size: rem(26px);
    background: #fff;
    width: auto;
    height: rem(32px);
    line-height: rem(32px);
    text-align: center;
    margin-right: rem(25px);
  }
  .oneLine {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .item-cell-bd {
    font-size: rem(26px);
    overflow: hidden;
    height: rem(32px);
    padding-left: rem(12px);
    line-height: rem(32px);
    a {
      color: #262626;
    }
  }
}
</style>
